





































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { VehicleReviveSteps, StepsJson } from '@/models/inventory/vehiclerevivesteps';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import {getVehicleReviveStepsHeaders} from '@/views/admin/vehiclerevivesteps/vehicleReviveSteps';
import {vehicleReviveStepsService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Stores: () => import('@/components/common/store.select.vue' ),
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class VehicleReviveStepsListPage extends Base {
    public headers: VHeaders[] = getVehicleReviveStepsHeaders(this);
    public pagedVehicleReviveSteps: VehicleReviveSteps[] = [];
    public pagedStepsJson: StepsJson[] = [];
    public pagination = new PaginationModel('step', false, -1);
    public loading: boolean = false;
    public flags = {
        loading: false,
    };
    public storeId: number = 0;
    public actions: any[] = [];
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('vehicleReviveSteps.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        loading: false,
        onAction: (): void => {
            this.deleteVehicleReviveSteps();
        },
    };
    public vehiclerevivestepsToDelete: VehicleReviveSteps = {
    };
    public preventPaginationCall: boolean = false;
    public items: any[] = [{ key: '0', value: 'New' }, { key: '1', value: 'Used' }]; // [ 'New', 'Used' ]
    public vehicleType: string = '';
    public reconId: string = '';
    public setActions() {
        this.actions = [{
            type: 'link',
            icon: 'fas fa-edit',
            title: this.$t('vehicleReviveSteps.vehicleReviveStepHeaders.gridAction.edit') as string,
            action: (model: VehicleReviveSteps) => {
                return {
                    name: 'admin.vehiclerevivesteps.edit',
                    params: {
                        id: this.reconId,
                        storeId: this.storeId,
                        stepId: model.id,
                        vehicleType: this.vehicleType.toString(),
                        isLocked: model.isFirstStep || model.isLastStep
                    },
                };
            },
        },
        {
            type: 'button',
            icon: 'fas fa-trash-alt',
            title: this.$t('vehicleReviveSteps.vehicleReviveStepHeaders.gridAction.delete') as string,
            color: 'error',
            action: (model: VehicleReviveSteps, storeId: string) => { this.confirmDelete(model); },
            visible: (model) => {
                    return !model.isFirstStep && !model.isLastStep;
                },
        },
        ];
    }
    public created() {
        this.storeId = Number(this.$route.params.storeId) ?
            Number(this.$route.params.storeId) : Number(this.userSession.storeId);
        this.vehicleType = this.$route.params.vehicleType ? this.$route.params.vehicleType : '0';
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addVehicleReviveStep') {
            if (!this.storeId || !this.vehicleType) {
                this.showAlert(false, this.$t('vehicleReviveSteps.alertStoreAndVehicleReviveRequired'));
                this.resetMethodName(methodName);
                return;
            }
            this.vehicleReviveStepsAdd();
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('vehicleReviveSteps.btnAddVehicleReviveStep'), disabled: false, visible: true, class: 'btn', label: this.$t('vehicleReviveSteps.btnAddVehicleReviveStep'), click: 'addVehicleReviveStep', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'vehicleReviveSteps');
        
        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        if (!this.checkUserRole(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
            this.getVehicleReviveSteps();
        }
        this.setActions();
    }
    public async getVehicleReviveSteps(): Promise<void> {
        try {
            this.flags.loading = true;
            this.pagedVehicleReviveSteps = [];
            this.pagedStepsJson = [];
            const resp = await vehicleReviveStepsService.getVehicleReviveSteps(this.storeId, this.pagination);
            this.pagedVehicleReviveSteps = resp.results as any;
            if (this.pagedVehicleReviveSteps.length > 0) {
                this.reconId = this.pagedVehicleReviveSteps[0].id.toString();
            }

            if (this.vehicleType && this.pagedVehicleReviveSteps.length > 0) {
                this.pagedStepsJson = resp.results[0].stepsJson;
                this.pagination.totalItems = this.pagedStepsJson.length;
                this.filterByVehicleType(this.vehicleType);
            }
        } finally {
            this.flags.loading = false;
        }
    }
    public updatePaging(paging: any) {
        this.pagination = paging;
    }
    public confirmDelete(item: VehicleReviveSteps): void {
        this.deleteDialog.model = true;
        this.vehiclerevivestepsToDelete = item;
    }
    public async deleteVehicleReviveSteps(): Promise<void> {
        try {
            this.deleteDialog.loading = true;
            await vehicleReviveStepsService
                .deleteSteps(Number(this.reconId), this.storeId, this.vehiclerevivestepsToDelete.id.toString());
            this.preventPaginationCall = true;
            this.showAlert(true, this.$t('vehicleReviveSteps.alertDeleteVehicleReviveStep'));
            await this.getVehicleReviveSteps();
        } finally {
            this.deleteDialog.model = false;
            this.deleteDialog.loading = false;
        }
    }
    public async updateStore(storeId: number): Promise<void> {
        this.storeId = storeId;
        await this.getVehicleReviveSteps();
    }
    public checkUserRole(routeRoles: string[]): boolean {
        return this.isAuthorizedToAccess(routeRoles);
    }
    public filterByVehicleType(selectedVehicleType): void {
        if (this.pagedVehicleReviveSteps.length > 0) {
            this.pagedStepsJson = this.pagedVehicleReviveSteps[0].stepsJson.filter((m) => {
                return m.type === ((selectedVehicleType === '0') ? 'New' : 'Used');
            });
            this.pagination.totalItems = this.pagedStepsJson.length;
        }
    }

    public vehicleReviveStepsAdd(): void {
        this.$router.push({
            name: 'admin.vehiclerevivesteps.add',
            params: {
                reconId: this.reconId ? this.reconId.toString() : '0',
                storeId: this.storeId.toString(),
                vehicleType: this.vehicleType.toString(),
            },
        });
    }
}
